import * as React from "react";
import InformationCard from "../../../../../elements/InformationCard";

interface IQuestionAnsweringModelOutputState {
  result: any;
  errorMessage: string;
}

class QuestionAnsweringModelOutput extends React.Component<{}, IQuestionAnsweringModelOutputState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      result: "",
      errorMessage: ""
    };
  }

  public processResponse = (response: any) => {
    if (response && response.result && response.result.answer) {
      this.setState({
        result: response.result.answer
      });
    } else {
      this.setState({
        errorMessage: "Unable to get answer."
      });
    }
  };

  public render() {
    return (
        <React.Fragment>
            {
              this.state.result ? <InformationCard>{this.state.result}</InformationCard> : <></>
            }
            {
              this.state.errorMessage ? <InformationCard>{this.state.errorMessage}</InformationCard> : <></>
            }
        </React.Fragment>
    );
  }
}

export default QuestionAnsweringModelOutput;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/output/QuestionAnswering/QuestionAnsweringModelOutput.tsx